import { forwardRef, type ReactNode } from 'react';
import { css, cx } from '@linaria/atomic';
import { LegacyButtonProps } from '../components/buttons/button-type';

type Props = Omit<LegacyButtonProps, 'children'> & {
  children?: ReactNode;
  trackingId?: string;
  className?: string;
};

const nakedButtonStyles = css`
  background: none;
  border: none;
  cursor: pointer;
  font-size: initial;
  padding: 0;
`;

export const NakedButton = forwardRef<HTMLButtonElement, Props>(
  ({ children, trackingId, type = 'button', className, ...rest }, ref) => (
    <button className={cx(nakedButtonStyles, className)} data-trackingid={trackingId} type={type} {...rest} ref={ref}>
      {children}
    </button>
  )
);
NakedButton.displayName = 'NakedButton';
